var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonPlayCircle = function SvgButtonPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "white",
    stroke: "#AE966B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM7.765 6.076C7.61087 5.97967 7.41659 5.97457 7.25762 6.06268C7.09864 6.15079 7 6.31824 7 6.5V11.5C7 11.6818 7.09864 11.8492 7.25762 11.9373C7.41659 12.0254 7.61087 12.0203 7.765 11.924L11.765 9.424C11.9112 9.33263 12 9.17239 12 9C12 8.82761 11.9112 8.66737 11.765 8.576L7.765 6.076Z",
    fill: "#AE966B"
  })));
};
export default SvgButtonPlayCircle;